import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "p-the-a01-whats-new-notice-panel__body" }
const _hoisted_3 = { class: "p-the-a01-whats-new-notice-panel__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _directive_touch = _resolveDirective("touch")!

  return (_ctx.isVisible)
    ? _withDirectives((_openBlock(), _createElementBlock("a", {
        key: 0,
        href: _ctx.url,
        class: "p-the-a01-whats-new-notice-panel",
        style: _normalizeStyle({ '--site-color': _ctx.colorCode })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "p-the-a01-whats-new-notice-panel__badge" }, "NEW", -1)),
          _createElementVNode("p", _hoisted_3, " 新着のお知らせが" + _toDisplayString(_ctx.unreadCount) + "件あります。 ", 1)
        ]),
        _createVNode(_component_IconBase, {
          class: "p-the-a01-whats-new-notice-panel__arrow",
          width: 24,
          height: 24,
          "view-box": "0 0 24 24",
          "icon-color": "#1f2021",
          "icon-name": "お知らせ一覧へ"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconArrowRight)
          ]),
          _: 1
        })
      ], 12, _hoisted_1)), [
        [_directive_touch, void 0, "tap"]
      ])
    : _createCommentVNode("", true)
}